export default __webpack_public_path__ + "97810d98da33843d7db6de470fecd6ec.png";